import React from 'react'
import { useSelector } from 'react-redux'
import { componentKeys } from 'keys/components'
import { Words, Page } from 'pages'

const Assessment = () => {
    const { words } = useSelector(state => state.words)
    const { assessment } = useSelector(state => state.assessment)

    const { assessment_def_visible_type, assessment_def_name, points } = assessment || {}
    const { assessmentHeader } = componentKeys

    return (
        <Page>
            <Words
                header={assessmentHeader}
                type={assessment_def_visible_type}
                name={assessment_def_name}
                words={words}
                points={points}
                showErrorTypes={true}
                settings={{
                    viewResults: true
                }}
            />
        </Page>
    )
}

export default Assessment